import { getSeedingProductOptions } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  GetSeedingProductOptionsServiceRequest,
  GetSeedingProductOptionsServiceResponse,
} from './get-seeding-product-options.dto';
import {
  GetSeedingProductOptionsServiceRequestSchema,
  GetSeedingProductOptionsServiceResponseSchema,
} from './get-seeding-product-options.dto';

export const getSeedingProductOptionsService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetSeedingProductOptionsServiceRequestSchema),
    async (
      request: GetSeedingProductOptionsServiceRequest,
    ): Promise<GetSeedingProductOptionsServiceResponse> => {
      const apiResponse = await getSeedingProductOptions(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '상품 옵션 조회에 실패했습니다.');
      }

      return apiResponse.data;
    },
    validateServiceResponse(GetSeedingProductOptionsServiceResponseSchema),
  ),
);
